<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">Edit K2 / K3 Sync Config</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="divShadow1">
    <!-- Loading Spinner -->
    @if (loadingData) {
<div class="text-center" style="padding: 20px;">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
}

    <!-- Form Content -->
    @if (!loadingData) {
<div class="container-fluid">
      <input type="hidden" id="sync_id" name="sync_id" [value]="configObj.SYNC_ID">
      
      <!-- Tax Year -->
      <div class="row form-group">
        <div class="col-sm-2">
          <label for="config_tax_year"><strong>Tax Year:</strong></label>
        </div>
        <div class="col-sm-2">
          <input class="form-control" 
                 type="text" 
                 id="config_tax_year" 
                 name="config_tax_year" 
                 [value]="configObj.TAX_YEAR" 
                 disabled>
        </div>
      </div>
      
      <!-- Sync Name -->
      <div class="row form-group">
        <div class="col-sm-2">
          <label for="sync_name"><strong>Sync Name:</strong></label>
        </div>
        <div class="col-sm-2">
          <input class="form-control" 
                 type="text" 
                 id="sync_name" 
                 name="sync_name" 
                 [value]="configObj.SYNC_NAME" 
                 disabled>
        </div>
      </div>

      <!-- Sync Desc -->
      <div class="row form-group">
        <div class="col-sm-2">
          <label for="sync_desc"><strong>Sync Desc:</strong></label>
        </div>
        <div class="col-sm-2">
          <input class="form-control" 
                 type="text" 
                 id="sync_desc" 
                 name="sync_desc" 
                 [value]="configObj.SYNC_DESC" 
                 disabled>
        </div>
      </div>

      <!-- Cron Expression (Read-only) -->
      <div class="row form-group">
        <div class="col-sm-2">
          <label for="cron_exp"><strong>Cron Expression:</strong></label>
        </div>
        <div class="col-sm-2">
          <input class="form-control" 
                 type="text" 
                 id="cron_exp" 
                 name="cron_exp" 
                 [value]="configObj.CRON_DESC" 
                 disabled>
        </div>
      </div>

      <!-- Start Date -->
      <div class="row form-group">
        <div class="col-sm-2">
          <label for="config_start_date"><strong>Start Date:</strong></label>
        </div>
        <div class="col-sm-1">
          <div class="input-group">
            <input 
              id="config_start_date" 
              type="date"
              class="form-control"
              [value]="getDateValueForInput(configObj.startDateObj)"
              (change)="onDateChange('start', $event)">
            <span class="input-group-addon" (click)="openDatePicker('start')" title="Open calendar">
              <i class="glyphicon glyphicon-calendar"></i>
            </span>
          </div>
        </div>
      </div>

      <!-- End Date -->
      <div class="row form-group">
        <div class="col-sm-2">
          <label for="config_end_date"><strong>End Date:</strong></label>
        </div>
        <div class="col-sm-1">
          <div class="input-group">
            <input 
              id="config_end_date" 
              type="date"
              class="form-control"
              [value]="getDateValueForInput(configObj.endDateObj)"
              (change)="onDateChange('end', $event)">
            <span class="input-group-addon" (click)="openDatePicker('end')" title="Open calendar">
              <i class="glyphicon glyphicon-calendar"></i>
            </span>
          </div>
        </div>
      </div>

      <!-- Status Toggle Switch -->
      <div class="row form-group">
        <div class="col-sm-2">
          <label for="is_active"><strong>Status:</strong></label>
        </div>
        <div class="col-sm-2">
          <label class="switch">
            <input type="checkbox" 
                   id="is_active" 
                   name="is_active"
                   [checked]="configObj.IS_ACTIVE === 'Y'"
                   (change)="onStatusToggle($event)">
            <span class="slider"></span>
          </label>
        </div>
      </div>

      <!-- Buttons -->
      <div class="col-sm-4">
        &nbsp;
        <div class="row form-group" style="float:right;">
          <div class="col-sm-12">
            <button id="FTC_INV_CRUD_2" 
                    class="btn btn-info btn-sm" 
                    type="button"
                    [disabled]="isSaveClicked || crudLoading" 
                    (click)="save()">
              @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
            </button>&nbsp;
            <button id="FTC_INV_CRUD_3" 
                    class="btn btn-warning btn-sm" 
                    type="button" 
                    (click)="cancel()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
}
  </div>
</div>

